import React, { createContext } from 'react';

import type { ChatInputInternalProps } from './types';

/** The Home experiment opts in; every other prompt input keeps Chat behaviour. */
export const SearchModeContext: React.Context<ChatInputInternalProps['searchMode']> =
	createContext<ChatInputInternalProps['searchMode']>(undefined);
